import React from 'react';
import TripsSection from '../sections/TripsSection/TripsSection';

const Trips = () => {
  return (
    <TripsSection />
  )
}

export default Trips